import {
  type AllowedActionsToReceiveFromCanvasAppTypes,
  type AllowedActionsToReceiveFromCanvasAppPayloads,
} from '@packages/systems/designer/canvas';
import {getCanvasAppParentOrigin} from '@packages/utilities/canvas-origin';

/**
 * Allows to dispatch flux actions in the Designer App from the Canvas App. Only limited amount of actions are allowed.
 * Check `allowedActionsToReceiveFromCanvasApp` for list of all allowed actions
 */
export const dispatchInDesigner = <
  T extends AllowedActionsToReceiveFromCanvasAppTypes,
>({
  type,
  payload,
}: {
  type: T;
  payload?: AllowedActionsToReceiveFromCanvasAppPayloads[T];
}) => {
  const message = {method: 'dispatch', payload, type};
  const designerAppOrigin = getCanvasAppParentOrigin(window);

  if (designerAppOrigin) {
    window.parent.postMessage(message, designerAppOrigin);
  }
};
